<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <ul class="slickInitVue" id="slick-blog-feed">
                    <li v-for="article in articles" class="slick-slide">
                        <a :href="'/' + article.slug">
                            <div class="card mb-3">
                                <LazyImage
                                    :imageSrc="
                                        'https://barons-eden-cdn.fra1.digitaloceanspaces.com/' +
                                        article.img
                                    "
                                    :title="article.title"
                                    class="image-header"
                                />
                                <div class="card-body">
                                    <h5 class="ffs text-uppercase font-gold">
                                        {{ article.title }}
                                    </h5>
                                    <p>{{ article.summary }}</p>
                                </div>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import LazyImage from "./LazyImage";
export default {
    props: {},

    components: {
        LazyImage,
    },

    data() {
        return {
            articles: null,
        };
    },

    mounted() {
        console.log("Home feed component mounted");
        this.getFeed();
    },

    computed: {},

    watch: {},

    methods: {
        getFeed() {
            axios.get("/system/hch-home-feed").then((response) => {
                this.articles = response.data;
                Vue.nextTick(function () {
                    $(".slickInitVue").slick({
                        dots: true,
                        arrows: false,
                        infinite: true,
                        autoplay: true,
                        speed: 300,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        responsive: [
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                },
                            },
                            // You can unslick at a given breakpoint now by adding:
                            // settings: "unslick"
                            // instead of a settings object
                        ],
                    });
                });
            });
        },
    },
};
</script>
